import React from 'react';
import { Link } from 'react-router-dom';

const WarehouseNavbar = () => (
  <header className="sticky top-0 z-40 border-b border-emerald-100 bg-white/95 backdrop-blur">
    <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.35em] text-emerald-500">
          Puerto Rico Windows & Doors
        </p>
        <p className="text-lg font-bold text-emerald-900">Panel de Almacén</p>
      </div>
      <Link
        to="/operations"
        className="rounded-full border border-emerald-200 px-4 py-2 text-sm font-semibold text-emerald-800 hover:bg-emerald-50"
      >
        Ver operaciones
      </Link>
    </div>
  </header>
);

export default WarehouseNavbar;
